var map = {
	"./Hisco_logo.png": 1352,
	"./andrews_logo.png": 1353,
	"./asko_logo.png": 1354,
	"./asset-dev_logo.png": 1355,
	"./brady_logo.png": 1356,
	"./carlisle_logo.png": 1357,
	"./crane_logo.png": 1358,
	"./demo_logo.png": 1359,
	"./gmn_logo.png": 1360,
	"./keycompounding_logo.png": 1361,
	"./kuslers_logo.png": 1362,
	"./orion_logo.png": 1363,
	"./sbs_logo.png": 1364,
	"./skills_logo.png": 1365,
	"./slayer_logo.png": 1366,
	"./toolgauge_logo.png": 1367,
	"./transpak_logo.png": 1368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2823;